import React from 'react';
import { Step } from '@/hooks';
import { StepsNavigation } from '../components/StepsNavigation';
import { DIRECTION } from '@/components/views/Resolution886/enums';
import { useResolution886Report } from '@/context/Resolution886Report';

interface HeaderStepProps {
	steps: Step[];
}

export function HeaderStep({ steps = [] }: Readonly<HeaderStepProps>): JSX.Element {
	const { currentStep, reviewConsolidated, handleStepNavigationClick } = useResolution886Report();

	return (
		<StepsNavigation
			steps={steps}
			isComplete={reviewConsolidated}
			currentStep={currentStep}
			direction={DIRECTION.HORIZONTAL}
			onStepNagivationClick={handleStepNavigationClick}
		/>
	);
}
